@import '../../utils/control-density.css';
@import '../../utils/chrome-header.css';

:host {
  display: block;
  flex: 0 0 auto;
  box-sizing: border-box;
}

.panel-tool-header {
  height: var(--dimension-size-600);
  color: var(--color-foreground-primary);
  -webkit-user-select: none;
  user-select: none;
}

.panel-tool-header__leading:empty,
.panel-tool-header__trailing:empty {
  display: none;
}

.panel-tool-header__trailing {
  gap: var(--dimension-space-050);
  justify-content: flex-end;
}

ds-text.panel-tool-header__heading {
  display: inline-flex;
  flex: 1 1 0;
  align-items: center;
  width: auto;
  min-width: 0;
  height: var(--ds-control-height);
  padding-inline: calc(var(--ds-control-padding-inline) + var(--ds-control-label-inset));
  box-sizing: border-box;
  text-align: left;
  -webkit-user-select: none;
  user-select: none;
}
